<template>


  <h1>Lab Orders</h1>
  <div id="orders-wrapper" class="FCNW">
    <div id="filter-wrapper">

      <!-- STATUS/SEARCH FILTER ROW -->
      <div class="filter-row FRNW">
        <!-- STATUS FILTER -->
        <div class="FRNW" style="position: relative;">

          <label style="font-weight: bold;">Status Filters:</label>
          <label 
            :title="statusFilterComputed.title"
            style="cursor: help; margin: 0 .5rem;"

          >
            {{ statusFilterComputed.text }}
          </label>

          <!-- FILTER DROPDOWN BTN -->
          <div 
            id="filter-menu-btn"
            class="FRNW" 
            @click="toggleStatusFilterMenu"
            title="click to toggle status filter drop down"
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-menu-button" viewBox="0 0 16 16">
              <path d="M0 1.5A1.5 1.5 0 0 1 1.5 0h8A1.5 1.5 0 0 1 11 1.5v2A1.5 1.5 0 0 1 9.5 5h-8A1.5 1.5 0 0 1 0 3.5zM1.5 1a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 .5.5h8a.5.5 0 0 0 .5-.5v-2a.5.5 0 0 0-.5-.5z"/>
              <path d="m7.823 2.823-.396-.396A.25.25 0 0 1 7.604 2h.792a.25.25 0 0 1 .177.427l-.396.396a.25.25 0 0 1-.354 0M0 8a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm1 3v2a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2zm14-1V8a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v2zM2 8.5a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5m0 4a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 0 1h-6a.5.5 0 0 1-.5-.5"/>
            </svg>
          </div>

          <!-- FILTER MENU -->
          <div
            id="filter-menu-div"
            v-if="showStatusFilterMenu"
          >
            <div>
              <label>Select All</label>
              <input 
                type="checkbox" 
                @change="toggleSelectAllStatusFilters"
                v-model="statusSelectAll"
              >
            </div>
            <div v-for="status of orderStatusArr" :key="status">
              <label>{{ `${status} (${orderStatusCountMap[status]})` }}</label>
              <input 
                type="checkbox" 
                v-model="orderStatusFilterMap[status]"
                @change="(e) => setStatusFilterLocalStorage( status, e.target.checked )"
              >
            </div>
          </div>
        </div>


        <!-- TEXT FILTER -->
        <div class="FRNW">
          <label style="font-weight: bold;">Search:</label>
          <input 
            id="search-input"
            type="text" 
            v-model="searchText" 
            placeholder="order # or user name"
          >
          <div 
            class="info-icon"
            title="Search by order number or name."
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-info-circle" viewBox="0 0 16 16">
              <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16"/>
              <path d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0"/>
            </svg>
          </div>
        </div>
      </div>


      <!-- FILTER BY DATE ROW -->
      <div class="FRNW">
        <label class="bold">Start:</label>
        <input 
          type="date" 
          style="margin-right: 1rem;"
          v-model="startDate"
        >
        <label class="bold">End:</label>
        <input 
          type="date" 
          style="margin-right: 1rem;"
          v-model="endDate"
          @change="console.log(this.endDate)"
        >
      </div>
      

    </div>
    <div id="orders-table">
      <div id="table-header" class="FRNW">
        <div class="col-1">Order #</div>
        <div class="col-2">Order Date</div>
        <div class="col-3"># of Items</div>
        <div class="col-4">Status</div>
        <div class="col-5">
          <!-- COLUMN FOR DETAILS BTN -->
        </div>

      </div>
      <div id="table-contents-wrapper">
        <div 
          v-for="order of filteredOrders"
          :key="order._id"
          class="FCNW table-line-wrapper"
        >
          <div class="table-line FRNW">
            <div class="col-1">{{ order.orderNumber }}</div>
            <div class="col-2">{{ new Date(order.orderDate).toLocaleDateString() }}</div>
            <div class="col-3">{{ (order.itemList || []).length }}</div>
            <div class="col-4">{{ order.status }}</div>
            <div class="col-5">
              <ModernButtonVue
                :btnText="'Details'"
                :btnSize="'small'"
                :clickFunc="() => toggleOrder( order._id )"
              />
            </div>
          </div>
          <transition
            name="expand"
            @before-enter="beforeEnter"
            @enter="enter"
            @leave="leave"
          >
            <div 
              v-if="order.show"
              class="table-line-details FCNW"
              :id="order._id"
              ref="details"
            >
              <div class="FRNW">
                <div class="FCNW details-div">
                  <div class="details-div-header">User Info</div>
                  <div>{{ order.firstName + ' ' + order.lastName }}</div>
                  <div v-for="val of Object.values( order.address )" :key="val">
                    {{ val }}
                  </div>
                </div>
                <div class="FCNW details-div">
                  <div 
                    class="FRW table-div-top-row" 
                  >
                    <div>
                      <strong>Order Total:</strong> ${{ order.totalCostDollars }}
                    </div>
                    <div>
                      <strong>Neg Return:</strong> {{ order?.negReturnDetails?.type || 'N/A' }}
                    </div>
                  </div>
                  <table>
                    <tr>
                      <th v-for="header of lineTableHeaders" :key="header">
                        {{ header }}
                      </th>
                    </tr>
                    <tr v-for="(line, idx) of order.itemList" :key="idx">
                      <td>{{ idx + 1 }}</td>
                      <td v-for="key of lineValues" :key="key">
                        {{ line.itemDetails?.[key]?.optionText || 'N/A' }}
                      </td>
                      <td>{{ line.qty }}</td>
                      <td>{{ '$' + line.itemTotal }}</td>
                    </tr>
                  </table>
                </div>
              </div>
              <div class="FRW" style="align-items: center;">

                <!-- TC LABEL INPUT -->
                <div class="FRNW label-input-div">
                  <input 
                    type="number" 
                    v-model="twinCheckLabelNew"
                    min="0"
                    placeholder="e.g. 8383"
                  >
                  <ModernButtonVue
                    :btnSize="'small'"
                    :btnText="'Add Label'"
                    :clickFunc="() => updateTwinCheckLabel( order, true, false )"
                    :showBorder="true"
                    :disabled="!twinCheckLabelNew"
                  />
                </div>

                <!-- TC LABELS -->
                <div class="FRW">
                  <label><strong>Twin Check Labels:</strong></label>
                  <div
                    v-for="label of order.twinCheckLabels"
                    :key="label"
                    class="tc-label"
                  >
                    <div 
                      class="remove-tc-label" 
                      @click="updateTwinCheckLabel(order, false, true, label)"
                      title="remove TC label from order"
                    >
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x-circle" viewBox="0 0 16 16">
                        <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16"/>
                        <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708"/>
                      </svg>
                    </div>
                    <div class="label-text">{{ label }}</div>
                  </div>
                </div>

              </div>
              <div class="FRNW" style="justify-content: space-between; margin: .25rem;">
                <div class="FRNW">
                  <label><strong>Order Status:</strong></label>
                  <select 
                    v-model="order.status"
                    @change="changeStatus( order._id, order.status, 'status' )"
                  >
                    <option 
                      v-for="status of orderStatusArr"
                      :key="status"
                      :value="status"
                    >
                      {{ status }}
                    </option>
                  </select>
                </div>
                <div 
                  v-if="order.status?.toLowerCase() === 'custom'"
                  class="FRNW"
                >
                  <label>Custom Status Text:</label>
                  <input 
                    type="text" 
                    v-model.trim="order.customStatus"
                    placeholder="Custom status text"
                    @change="changeStatus( order._id, order.customStatus, 'customStatus' )"
                  >

                </div>
              </div>
              <div class="FRNW">
                <ModernButtonVue
                  :btnSize="'small'"
                  :btnText="'Create Order PDF'"
                  :clickFunc="() => genOrderPdf( order )"
                />
              </div>
              
            </div>

          </transition>

        </div>

      </div>

    </div>

  </div>
</template>


<script>
import ModernButtonVue from './basicComponents/ModernButton.vue';

import { GetDate, IsMobileDevice, LocalStorageFuncs } from '../utils';
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
pdfMake.vfs = pdfFonts.pdfMake.vfs;

// GLOBALS
// --------------------
const API = process.env.VUE_APP_API_URL;
let NOTIFICATION, FLA_AXIOS;
const NAME = 'OrdersViewLab';
// --------------------

export default {
  name: NAME,
  components: {
    ModernButtonVue,
  },
  props: {
    labId: String,
    presignedLogoUrl: String,
    labOptionsId: String,
  },
  data() {
    return {
      orders: [],
      lineTableHeaders: [ 
        'Line', 
        'Film Chemistry', 
        'Format', 
        'Neg Option', 
        // 'Neg Return Option',   // removed on FIL-11
        'Push/Pull', 
        'Qty', 
        'Item Total' 
      ],
      lineValues: [ 
        'filmChemistry', 
        'format', 
        'negativeOptions', 
        // 'negativeReturnOptions',   // removed on FIL-11
        'pushPullProcessing', 
      ],

      statusFilter: '',
      dateFilterStart: null,
      dateFilterEnd: null,

      orderStatusArr: [],
      orderStatusCountMap: {},
      orderStatusFilterMap: {},
      showStatusFilterMenu: false,
      statusSelectAll: false,

      twinCheckLabelNew: null,

      searchText: '',

      startDate: null,
      endDate: null,
    }
  },
  computed: {
    filteredOrders() {
      let orders = this.orders;

      // filter by selected status
      const statusFilters = this.orderStatusArr.filter( status => this.orderStatusFilterMap[status] );
      orders = orders.filter( order => statusFilters.includes( order.status ) );

      const text = this.searchText.trim();
      if ( text ) {
        const re = RegExp( text, 'i' );
        orders = orders.filter( order => {
          const { orderNumber, firstName, lastName } = order;
          const fullName = `${firstName} ${lastName}`;
          return (
            re.test( fullName ) ||
            re.test( orderNumber )
          );
        } );
      }

      if ( this.endDate ) {
        const _endDate = GetDate( this.endDate, false );
        orders = orders.filter( o => {
          const orderDate = new Date(o.orderDate);
          return orderDate <= _endDate;
        } );
      }

      if ( this.startDate ) {
        const _startDate = GetDate( this.startDate, true );
        orders = orders.filter( o => {
          const orderDate = new Date( o.orderDate );
          return orderDate >= _startDate;
        } );
      }

      return orders;
    },

    statusFilterComputed() {
      const statusFilters = this.orderStatusArr.filter( status => this.orderStatusFilterMap[status] );
      const numStatusFilters = statusFilters.length;

      let title = '';
      let text = '';
      if ( numStatusFilters === this.orderStatusArr.length ) {
        text = 'ALL';
        title = 'All filters selected';
      }
      else if ( numStatusFilters === 0 ) {
        text = 'No filters selected';
        title = 'Select a filter to display orders.';
      }
      else if ( statusFilters.length === 1 ) {
        text = statusFilters[0];
      }
      else {
        title = statusFilters.join(' | ');
        text = `${numStatusFilters} selected`;
      }

      return {
        title: title, 
        text: text
      };
    }
  },
  methods: {

    fetchLabOrders() {
      const userId = LocalStorageFuncs.fetchUserId();
      FLA_AXIOS('get', API + `/api/order/labOrders/${userId}`)
      .then( res => {
        const { orders } = res.data;
        
        this.orders = orders || [];
        this.fetchOrderStatusArr();   // call this here because we want the orders so we can build the map
      } )
      .catch( e => console.log(e) );
    },

    fetchLabOrdersByOptionsId() {
      FLA_AXIOS('get', API + `/api/order/labOrdersByOptionsId/${this.labOptionsId}`)
      .then( res => {
        const { orders } = res.data;
        
        this.orders = orders || [];
        this.fetchOrderStatusArr();   // call this here because we want the orders so we can build the map
      } )
      .catch( e => console.log(e) );
    },

    fetchOrderStatusArr() {
      FLA_AXIOS('get', API + '/api/order/orderStatusArr')
      .then( res => {
        const { orderStatusArr } = res.data;
        this.orderStatusArr = orderStatusArr || [];

        this.createOrderStatusMap();
      })
      .catch( e => console.log(e) );
    },

    createOrderStatusMap() {
      // build a count for each status to be shown in filter drop down
      let setAllTrue = true;    // flag so we don't have to loop again
      this.orderStatusArr.forEach( x => {
        // build count map
        this.orderStatusCountMap[x] = 0;

        // build filter map, check localstorage first
        const ls = this.fetchStatusFilterLocalStorage( x );
        if ( ls === 'false' ) setAllTrue = false;

        // if ls === null then we assume no value set so we set it to true...
        // ... if not then we need to compare ls to true because ls is a String
        this.orderStatusFilterMap[x] = ( ls === null )
          ? true
          : ls === 'true';
      } );

      // set select all checkbox
      this.statusSelectAll = setAllTrue;

      

      this.orders.forEach( order => {
        this.orderStatusCountMap[ order.status ] ++;
      } );
    },

    changeStatus( orderId, value, field ) {
      const data = { orderId, field, value: value.trim() };
      FLA_AXIOS('post', API + '/api/order/updateOrderStatus', data)
      .then( res => {
        this.showNotification( res.data );
        if ( res.data.clearCustomStatus ){
          const order = this.orders.find( x => x._id === orderId );
          order.customStatus = '';
        }
        this.createOrderStatusMap();
      } )
      .catch( e =>  console.log(e) );
    },

    updateTwinCheckLabel( order, add, remove, numToRemove ) {
      const data = {
        orderId: order._id,
        newLabelNum: this.twinCheckLabelNew,
        add,
        remove,
        numToRemove
      };
      FLA_AXIOS('post', API + '/api/order/updateTwinCheckLabels', data)
      .then( res  => {
        this.showNotification( res.data );

        if ( add ) this.twinCheckLabelNew = null;
        
        const { twinCheckLabels } = res.data;
        order.twinCheckLabels = twinCheckLabels;
      } )
      .catch( e => console.log(e) );
    },

    showNotification( data ) {
      window.showNotification( data );
    },

    async genOrderPdf( order ) {

      const { 
        firstName, lastName, address, labName,
        orderNumber, orderDate, itemList, status,
        negReturnDetails,
       } = order;
      const { street, city, apartmentNumber, state, zipCode } = address;
      const negReturnString = `Neg Return: ${negReturnDetails?.type || 'N/A'}`

      // user and lab info 
      const infoTable = {
        widths: ['auto', '*', 'auto'],
        body: [
          [`${firstName} ${lastName}`, '', {text: labName, bold: true}],
          [street, '', ''],
          // [street, '', {image: 'logo'}],
          // [apartmentNumber, '', ''],   // this gets added later via if statement.
          [city, '', ''],
          [state, '', ''],
          [zipCode, '', ''],
          [negReturnString, '', '']
        ]
      };

      // splice in apartment number
      if ( apartmentNumber ) {
        infoTable.body.splice(2, 0, [`Apt #: ${apartmentNumber}`, '', ''])
      }

      // high level order detailsz
      const highLevelTable = {
        widths: ['*', '*', '*', '*'],
        headerRows: 1,
        body: [
          ['Order #', 'Order Date', '# of Items', 'Status' ],
          [
            orderNumber, 
            (new Date(orderDate).toLocaleDateString() || 'na'), 
            itemList.length, 
            status
          ]
        ]
      };

      highLevelTable.body[0] = highLevelTable.body[0].map( x => {
        return {
          text: x,
          style: 'headerRow'
        };
      } );



      // order details
      const lineTableHeaders = this.lineTableHeaders.map( x => x );
      lineTableHeaders.pop();

      const detailsTable = {
        widths: lineTableHeaders.map( x => 'auto'),
        headerRows: 1,
        body: [
          lineTableHeaders.map( x => {
            return {
              text: x,
              style: 'headerRow'
            };
          } ),
        ]
      };

      // edit to make Film Chemistry make the balance of the space
      detailsTable.widths[1] = '*';

      // create item list
      let c = 1;      // counter
      itemList.forEach( item => {
        const arr = [c];
        this.lineValues.forEach( v => {
          arr.push( item?.itemDetails?.[v]?.optionText || 'err' );    // since pdfmake doesnt have the best error logging.
        } );
        arr.push( item.qty );
        detailsTable.body.push( arr );
      } );

      // creates a margin between tables
      const margin = ( num ) => {
        return { text: '', margin: [0, Number(num)] };
      };
      

      // finally build the docDef structure to generate the PDF
      const docDef = {
        content: [
          {
            text: `${order.orderNumber} Order Details`,
            style: 'header'
          },
          margin( 10 ),
          { 
            table: infoTable,
            layout: 'noBorders'
          },
          margin(20),
          { table: highLevelTable },
          margin(20),
          { table: detailsTable },
        ],
        // images: {
        //   logo: this.presignedLogoUrl
        // },
        styles: {
          header: {
            fontSize: 22,
            bold: true,
            alignment: 'center'
          },
          headerRow: {
            bold: true,
            fillColor: 'gainsboro'
          }
        }
      };

      // add logo if it exists
      if ( this.presignedLogoUrl ) {
        docDef.images = {
          logo: this.presignedLogoUrl
        };
        const imageObj = {
          image: 'logo',
          fit: [200, 85],
          rowSpan: 5
        }
        infoTable.body[1][2] = imageObj;
      }

      

      try {
        pdfMake.createPdf(docDef).open();
      } 
      catch (error) {
        console.error(error)
      }

    },

    toggleStatusFilterMenu() {
      this.showStatusFilterMenu = !this.showStatusFilterMenu;
    },

    toggleSelectAllStatusFilters( event ) {
      const val = event.target.checked;
      this.orderStatusArr.forEach( status => {
        this.orderStatusFilterMap[ status ] = val;
        this.setStatusFilterLocalStorage( status, val );
      } ) },

    setStatusFilterLocalStorage( status, val ) {
      const key = `FLA_STATUS_FILTER_${status}`
      localStorage.setItem(key, val);

      // now lets check if select all needs to change
      this.statusSelectAll = Object
        .values( this.orderStatusFilterMap )
        .every( x => x );
    },

    fetchStatusFilterLocalStorage( status ) {
      const key = `FLA_STATUS_FILTER_${status}`;
      return localStorage.getItem( key );
    },





    // this is for order details
    // -------------------------
    toggleOrder( orderId ) {
      const order = this.orders.find( order => order._id === orderId );
      order.show = !order.show;
    },

    beforeEnter(el) {
      el.style.height = '0';
    },

    enter(el) {
      console.log(el.clientHeight, el.scrollHeight);

      // this isn't the best solution
      // check if there is a scroll bar, if not lets add some additional padding to the bottom
      const main = document.getElementById('main');
      const mainHasScrollBar = main.scrollHeight > main.clientHeight;
      const scrollHeight = (mainHasScrollBar)
        ? el.scrollHeight
        : el.scrollHeight + 16;
      // el.style.height = el.scrollHeight + 'px';    // old
      el.style.height = scrollHeight + 'px';
    },

    leave(el) {
      el.style.height = el.scrollHeight + 'px';
      // el.style.minHeight = el.scrollHeight + 'px';
      requestAnimationFrame(() => {
        el.style.height = '0';
      });
    },
    // -------------------------

  },
  mounted() {

    FLA_AXIOS = window.FLA_Axios;
    NOTIFICATION = window.Notification;

    // fetch orders by labId or labOptionsId
    ( this.labOptionsId )
      ? this.fetchLabOrdersByOptionsId()
      : this.fetchLabOrders();
    
    // if not mobile then focus on Search input
    if ( !IsMobileDevice() ) {
      document.getElementById('search-input').focus();
    }

    
  }
}

</script>

<style scoped>

#orders-wrapper{
  box-sizing: border-box;
  border-color: gray;
  border-radius: var(--border-radius);
}

#filter-wrapper {
  background-color: #96C9F4;
  padding: .5rem .25rem;
  justify-content: space-between;
  display: flex;
  border-radius: var(--border-radius) var(--border-radius) 0 0;
  border: var(--border-orders);
  border-bottom: 0;
  flex-direction: column;
}

#table-header, .table-line {
  justify-content: space-between;
}
#table-header {
  font-weight: bold;
  background-color: gainsboro;
  padding: .75rem 0;
  border-left: var(--border-orders);
  border-right: var(--border-orders);
}

.table-line {
  align-items: center;
  margin: .25rem 0;
}
.table-line-wrapper {
  border-left: var(--border-orders);
  border-right: var(--border-orders);
}
.table-line-wrapper:nth-of-type(odd) {
  background-color: #F5F7F8;
}
.table-line-wrapper:last-of-type{
  border-bottom: var(--border-orders);
  border-radius: 0 0 var(--border-radius) var(--border-radius);
}

.table-line-details {
  overflow: hidden;
  transition: all .3s;
}

.details-div {
  background-color: gainsboro;
  border-radius: 10px;
  border: 1px solid black;
  margin: .5rem;
  padding: .25rem;
}
.details-div div {
  text-align: start;
}

.details-div-header {
  text-align: center !important;
  font-weight: bold;
  text-decoration: underline;
}

.table-div-top-row {
  justify-content: space-between;
  margin: .25rem;
  padding: .25rem;
  border-radius: var(--border-radius);
  background-color: var(--fla-gray);
}

label {
  margin: 0 .25rem ;
}

.col-1 {
  width: 7rem;
}
.col-2,
.col-3,
.col-4 {
  width: 6rem;
}
.col-5 {
  width: 12rem;
}

.tc-label {
  background-color: silver;
  padding: .2rem .5rem;
  margin: 0 .5rem;
  border-radius: 8px;
  font-weight: bold;
  position: relative;
}
.label-text {
  border-bottom: 3px solid green;
}

.remove-tc-label {
  position: absolute;
  top: -.5rem;
  right: -.5rem;
  cursor: pointer;
  border-radius: 50%;
}
.remove-tc-label svg {
  border-radius: 50%;
  background-color: white;
}
.remove-tc-label svg:hover {
  color: red;
}

.info-icon {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 .5rem;
  cursor: help;
}

.label-input-div input,
.label-input-div button {
  margin: 0 .5rem;
}

.filter-row {
  justify-content: space-between;
  margin-bottom: .25rem;
}

#filter-menu-btn {
  justify-content: center;
  align-items: center;
  cursor: pointer;
}

#filter-menu-div {
  position: absolute;
  left: 0;
  top: 1.5rem;
  background-color: var(--fla-gray);
  padding: .5rem;
  border-radius: var(--fla-border-radius);
  border: 2px solid gray;
  display: flex;
  flex-direction: column;
}
#filter-menu-div div {
  display: flex;
  gap: 0.5rem; 
  white-space: nowrap; /* Prevent wrapping inside each div */
  justify-content: end;
}

#filter-menu-div input { cursor: pointer; }

</style>